<div class="title has-text-centered">
  Thank you, {$appState.user?.firstName || ""}. You're all set!
</div>
<p class="block">
  As soon as a local business makes an offer, we'll send you an email.
</p>

<div class="block has-text-centered">
  <button class="button is-primary" on:click={submit}
    >View current offers</button
  >
</div>


<script lang="ts">
  import { goto } from "@sveltech/routify";

  import { appState } from "../../../lib/appState";


  if (!$appState.auth_user.emailVerified) {
    sendEmailVerification();
  }

  function sendEmailVerification() {
    window.firebase.auth().currentUser!.sendEmailVerification({
      url: `${$appState.origin}/`,
    });
  }

  function submit() {
    $goto("/charity");
  }
</script>
